import { useState, useMemo, useRef } from 'react'
import { Search, X, Loader2, CheckCircle2 } from 'lucide-react'
import { matchRateApi } from '@/api/client'

// ─── Country list ─────────────────────────────────────────────────────

export const COUNTRIES: { code: string; name: string }[] = [
  { code: 'AF', name: 'Afghanistan' }, { code: 'AL', name: 'Albania' }, { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' }, { code: 'AO', name: 'Angola' }, { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AR', name: 'Argentina' }, { code: 'AM', name: 'Armenia' }, { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' }, { code: 'AZ', name: 'Azerbaijan' }, { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' }, { code: 'BD', name: 'Bangladesh' }, { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' }, { code: 'BE', name: 'Belgium' }, { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' }, { code: 'BT', name: 'Bhutan' }, { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia' }, { code: 'BW', name: 'Botswana' }, { code: 'BR', name: 'Brazil' },
  { code: 'BN', name: 'Brunei' }, { code: 'BG', name: 'Bulgaria' }, { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' }, { code: 'KH', name: 'Cambodia' }, { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' }, { code: 'CL', name: 'Chile' }, { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' }, { code: 'CG', name: 'Congo' }, { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Croatia' }, { code: 'CU', name: 'Cuba' }, { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' }, { code: 'DK', name: 'Denmark' }, { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' }, { code: 'EG', name: 'Egypt' }, { code: 'SV', name: 'El Salvador' },
  { code: 'EE', name: 'Estonia' }, { code: 'ET', name: 'Ethiopia' }, { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' }, { code: 'FR', name: 'France' }, { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' }, { code: 'GH', name: 'Ghana' }, { code: 'GR', name: 'Greece' },
  { code: 'GT', name: 'Guatemala' }, { code: 'GY', name: 'Guyana' }, { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' }, { code: 'HK', name: 'Hong Kong' }, { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' }, { code: 'IN', name: 'India' }, { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' }, { code: 'IQ', name: 'Iraq' }, { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' }, { code: 'IT', name: 'Italy' }, { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' }, { code: 'JO', name: 'Jordan' }, { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' }, { code: 'KR', name: 'South Korea' }, { code: 'KW', name: 'Kuwait' },
  { code: 'LA', name: 'Laos' }, { code: 'LV', name: 'Latvia' }, { code: 'LB', name: 'Lebanon' },
  { code: 'LY', name: 'Libya' }, { code: 'LI', name: 'Liechtenstein' }, { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' }, { code: 'MO', name: 'Macau' }, { code: 'MG', name: 'Madagascar' },
  { code: 'MY', name: 'Malaysia' }, { code: 'MV', name: 'Maldives' }, { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' }, { code: 'MX', name: 'Mexico' }, { code: 'MD', name: 'Moldova' },
  { code: 'MC', name: 'Monaco' }, { code: 'MN', name: 'Mongolia' }, { code: 'ME', name: 'Montenegro' },
  { code: 'MA', name: 'Morocco' }, { code: 'MZ', name: 'Mozambique' }, { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' }, { code: 'NP', name: 'Nepal' }, { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' }, { code: 'NI', name: 'Nicaragua' }, { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' }, { code: 'MK', name: 'North Macedonia' }, { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' }, { code: 'PK', name: 'Pakistan' }, { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' }, { code: 'PY', name: 'Paraguay' }, { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' }, { code: 'PL', name: 'Poland' }, { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' }, { code: 'RO', name: 'Romania' }, { code: 'RU', name: 'Russia' },
  { code: 'RW', name: 'Rwanda' }, { code: 'SA', name: 'Saudi Arabia' }, { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' }, { code: 'SG', name: 'Singapore' }, { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' }, { code: 'ZA', name: 'South Africa' }, { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' }, { code: 'SD', name: 'Sudan' }, { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' }, { code: 'SY', name: 'Syria' }, { code: 'TW', name: 'Taiwan' },
  { code: 'TZ', name: 'Tanzania' }, { code: 'TH', name: 'Thailand' }, { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' }, { code: 'TT', name: 'Trinidad and Tobago' }, { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' }, { code: 'UG', name: 'Uganda' }, { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'UAE' }, { code: 'GB', name: 'United Kingdom' }, { code: 'US', name: 'United States' },
  { code: 'UY', name: 'Uruguay' }, { code: 'UZ', name: 'Uzbekistan' }, { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' }, { code: 'YE', name: 'Yemen' }, { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' }, { code: 'XK', name: 'Kosovo' }, { code: 'PS', name: 'Palestine' },
  { code: 'PR', name: 'Puerto Rico' }, { code: 'GI', name: 'Gibraltar' },
]

export function getFlagEmoji(code: string): string {
  try {
    return String.fromCodePoint(...code.toUpperCase().split('').map(c => 0x1F1E6 + c.charCodeAt(0) - 65))
  } catch { return '' }
}

const ISO3_TO_ISO2: Record<string, string> = {
  AFG: 'AF', ALB: 'AL', DZA: 'DZ', AND: 'AD', AGO: 'AO', ATG: 'AG',
  ARG: 'AR', ARM: 'AM', AUS: 'AU', AUT: 'AT', AZE: 'AZ', BHS: 'BS',
  BHR: 'BH', BGD: 'BD', BRB: 'BB', BLR: 'BY', BEL: 'BE', BLZ: 'BZ',
  BEN: 'BJ', BTN: 'BT', BOL: 'BO', BIH: 'BA', BWA: 'BW', BRA: 'BR',
  BRN: 'BN', BGR: 'BG', BFA: 'BF', BDI: 'BI', KHM: 'KH', CMR: 'CM',
  CAN: 'CA', CHL: 'CL', CHN: 'CN', COL: 'CO', COG: 'CG', CRI: 'CR',
  HRV: 'HR', CUB: 'CU', CYP: 'CY', CZE: 'CZ', DNK: 'DK', DOM: 'DO',
  ECU: 'EC', EGY: 'EG', SLV: 'SV', EST: 'EE', ETH: 'ET', FJI: 'FJ',
  FIN: 'FI', FRA: 'FR', GEO: 'GE', DEU: 'DE', GHA: 'GH', GRC: 'GR',
  GTM: 'GT', GUY: 'GY', HTI: 'HT', HND: 'HN', HKG: 'HK', HUN: 'HU',
  ISL: 'IS', IND: 'IN', IDN: 'ID', IRN: 'IR', IRQ: 'IQ', IRL: 'IE',
  ISR: 'IL', ITA: 'IT', JAM: 'JM', JPN: 'JP', JOR: 'JO', KAZ: 'KZ',
  KEN: 'KE', KOR: 'KR', KWT: 'KW', LAO: 'LA', LVA: 'LV', LBN: 'LB',
  LBY: 'LY', LIE: 'LI', LTU: 'LT', LUX: 'LU', MAC: 'MO', MDG: 'MG',
  MYS: 'MY', MDV: 'MV', MLI: 'ML', MLT: 'MT', MEX: 'MX', MDA: 'MD',
  MCO: 'MC', MNG: 'MN', MNE: 'ME', MAR: 'MA', MOZ: 'MZ', MMR: 'MM',
  NAM: 'NA', NPL: 'NP', NLD: 'NL', NZL: 'NZ', NIC: 'NI', NER: 'NE',
  NGA: 'NG', MKD: 'MK', NOR: 'NO', OMN: 'OM', PAK: 'PK', PAN: 'PA',
  PNG: 'PG', PRY: 'PY', PER: 'PE', PHL: 'PH', POL: 'PL', PRT: 'PT',
  QAT: 'QA', ROU: 'RO', RUS: 'RU', RWA: 'RW', SAU: 'SA', SEN: 'SN',
  SRB: 'RS', SGP: 'SG', SVK: 'SK', SVN: 'SI', ZAF: 'ZA', ESP: 'ES',
  LKA: 'LK', SDN: 'SD', SWE: 'SE', CHE: 'CH', SYR: 'SY', TWN: 'TW',
  TZA: 'TZ', THA: 'TH', TLS: 'TL', TGO: 'TG', TTO: 'TT', TUN: 'TN',
  TUR: 'TR', UGA: 'UG', UKR: 'UA', ARE: 'AE', GBR: 'GB', USA: 'US',
  URY: 'UY', UZB: 'UZ', VEN: 'VE', VNM: 'VN', YEM: 'YE', ZMB: 'ZM',
  ZWE: 'ZW', PSE: 'PS', XKX: 'XK', PRI: 'PR', GIB: 'GI',
}

const VALID_ISO2 = new Set(COUNTRIES.map(c => c.code))

function resolveCountry(token: string): string | null {
  const upper = token.toUpperCase()
  if (VALID_ISO2.has(upper)) return upper
  if (ISO3_TO_ISO2[upper]) return ISO3_TO_ISO2[upper]
  const lower = token.toLowerCase()
  const byName = COUNTRIES.find(c => c.name.toLowerCase() === lower)
  if (byName) return byName.code
  return null
}

function extractCountries(text: string): string[] {
  const tokens = text.split(/[,;\t\n]+/).map(t => t.trim()).filter(Boolean)
  const codes: string[] = []
  for (const token of tokens) {
    const code = resolveCountry(token)
    if (code && !codes.includes(code)) codes.push(code)
  }
  return codes
}

// ─── CountrySelect Component ─────────────────────────────────────────

export function CountrySelect({ selected, onChange }: { selected: string[]; onChange: (codes: string[]) => void }) {
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)
  const [feedback, setFeedback] = useState<{ message: string; type: 'success' | 'loading' | 'error' } | null>(null)
  const [pastedText, setPastedText] = useState<string | null>(null)

  const filtered = useMemo(() => {
    if (!search) return COUNTRIES
    const q = search.toLowerCase()
    const iso3Match = ISO3_TO_ISO2[search.toUpperCase()]
    return COUNTRIES.filter(c =>
      c.name.toLowerCase().includes(q) ||
      c.code.toLowerCase().includes(q) ||
      (iso3Match && c.code === iso3Match)
    )
  }, [search])

  const inputRef = useRef<HTMLInputElement>(null)

  const toggle = (code: string) => {
    onChange(selected.includes(code) ? selected.filter(c => c !== code) : [...selected, code])
    setSearch('')
    setTimeout(() => inputRef.current?.focus(), 0)
  }

  const selectAll = () => onChange([...new Set([...selected, ...filtered.map(c => c.code)])])
  const clearAll = () => onChange([])

  const applyExtracted = (codes: string[]) => {
    const valid = codes.filter(c => VALID_ISO2.has(c))
    if (valid.length === 0) return 0
    const merged = [...new Set([...selected, ...valid])]
    const added = merged.length - selected.length
    onChange(merged)
    return added
  }

  const showFeedback = (message: string, type: 'success' | 'loading' | 'error') => {
    setFeedback({ message, type })
    if (type !== 'loading') setTimeout(() => setFeedback(null), 3000)
  }

  const aiExtract = async (text: string) => {
    showFeedback('Extracting countries with AI...', 'loading')
    setPastedText(null)
    try {
      const res = await matchRateApi.extractCountries(text)
      const data = (res as any)?.data?.data || (res as any)?.data
      const codes = data?.codes as string[] | undefined
      if (codes && codes.length > 0) {
        const added = applyExtracted(codes)
        showFeedback(added > 0 ? `AI added ${added} countr${added === 1 ? 'y' : 'ies'}` : 'All countries already selected', 'success')
      } else {
        showFeedback('AI could not identify any countries', 'error')
      }
    } catch {
      showFeedback('AI extraction failed', 'error')
    }
    setSearch('')
  }

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const text = e.clipboardData.getData('text')
    if (!text || text.trim().length < 2) return
    const isMultiToken = text.includes(',') || text.includes('\n') || text.includes('\t') || text.includes(';') || text.trim().split(/\s+/).length > 1
    if (!isMultiToken) return
    e.preventDefault()

    const localCodes = extractCountries(text)
    if (localCodes.length > 0) {
      const added = applyExtracted(localCodes)
      showFeedback(added > 0 ? `Added ${added} countr${added === 1 ? 'y' : 'ies'}` : 'All countries already selected', 'success')
      setSearch('')
      const tokenCount = text.split(/[,;\t\n]+/).filter(t => t.trim()).length
      if (localCodes.length < tokenCount * 0.5) {
        setPastedText(text)
      }
    } else {
      aiExtract(text)
    }
  }

  return (
    <div className="relative">
      {/* Selected chips */}
      <div
        className="min-h-[42px] flex flex-wrap gap-1.5 p-2 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] cursor-text"
        onClick={() => setOpen(true)}
      >
        {selected.length === 0 && (
          <span className="text-sm text-[var(--text-muted)] py-0.5">Select countries or paste a list...</span>
        )}
        {selected.map(code => {
          const c = COUNTRIES.find(x => x.code === code)
          return (
            <span key={code} className="inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full bg-violet-500/15 text-violet-300 border border-violet-500/30">
              {getFlagEmoji(code)} {c?.name || code}
              <button onClick={e => { e.stopPropagation(); toggle(code) }} className="hover:text-red-400">
                <X size={10} />
              </button>
            </span>
          )
        })}
      </div>

      {/* Feedback message */}
      {feedback && (
        <div className={`absolute right-2 -top-6 text-[10px] ${
          feedback.type === 'success' ? 'text-emerald-400' :
          feedback.type === 'loading' ? 'text-violet-400' : 'text-red-400'
        } ${feedback.type === 'loading' ? 'animate-pulse' : ''}`}>
          {feedback.type === 'loading' && <Loader2 size={10} className="inline animate-spin mr-1" />}
          {feedback.message}
        </div>
      )}

      {/* AI refinement prompt */}
      {pastedText && (
        <div className="mt-1.5 flex items-center gap-2 p-2 rounded-lg bg-violet-500/5 border border-violet-500/20">
          <span className="text-[10px] text-[var(--text-secondary)] flex-1">Some items weren&apos;t matched locally. Try AI extraction?</span>
          <button
            onClick={() => aiExtract(pastedText)}
            className="text-[10px] px-2 py-1 rounded bg-violet-600 text-white hover:bg-violet-500 transition-colors whitespace-nowrap"
          >
            Extract with AI
          </button>
          <button
            onClick={() => setPastedText(null)}
            className="p-0.5 rounded hover:bg-[var(--bg-tertiary)] text-[var(--text-muted)]"
          >
            <X size={12} />
          </button>
        </div>
      )}

      {/* Dropdown */}
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => { setOpen(false); setSearch('') }} />
          <div className="absolute z-20 mt-1 w-full max-h-64 overflow-auto rounded-lg border border-[var(--border-color)] bg-[var(--bg-secondary)] shadow-xl">
            <div className="sticky top-0 bg-[var(--bg-secondary)] p-2 border-b border-[var(--border-color)]">
              <div className="flex items-center gap-2">
                <Search size={14} className="text-[var(--text-muted)]" />
                <input
                  ref={inputRef}
                  autoFocus
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  onPaste={handlePaste}
                  onKeyDown={e => {
                    if (e.key === 'Enter' && filtered.length > 0 && search.trim()) {
                      e.preventDefault()
                      toggle(filtered[0].code)
                    }
                  }}
                  placeholder="Search or paste a list (e.g. AU, NZ, SWE, Thailand)..."
                  className="flex-1 bg-transparent text-sm text-[var(--text-primary)] outline-none placeholder:text-[var(--text-muted)]"
                />
              </div>
              <div className="flex gap-2 mt-1.5">
                <button onClick={selectAll} className="text-[10px] text-violet-400 hover:text-violet-300">Select all visible</button>
                <button onClick={clearAll} className="text-[10px] text-red-400 hover:text-red-300">Clear all</button>
              </div>
            </div>
            {filtered.map(c => (
              <button
                key={c.code}
                onClick={() => toggle(c.code)}
                className={`w-full flex items-center gap-2 px-3 py-1.5 text-sm hover:bg-[var(--bg-tertiary)] transition-colors ${
                  selected.includes(c.code) ? 'text-violet-300 bg-violet-500/10' : 'text-[var(--text-secondary)]'
                }`}
              >
                <span className="text-xs">{getFlagEmoji(c.code)}</span>
                <span className="flex-1 text-left">{c.name}</span>
                <span className="text-[10px] text-[var(--text-muted)]">{c.code}</span>
                {selected.includes(c.code) && <CheckCircle2 size={12} className="text-violet-400" />}
              </button>
            ))}
            {filtered.length === 0 && (
              <div className="px-3 py-4 text-center text-sm text-[var(--text-muted)]">No countries match &ldquo;{search}&rdquo;</div>
            )}
          </div>
        </>
      )}
    </div>
  )
}
